'use client';

import { Menu } from 'lucide-react';
import type { Route } from 'next';
import Link from 'next/link';
import * as React from 'react';

import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';

export type HeaderLink = { name: string; href: Route | Route<'/docs'> };

export function MobileMenuSheet({ links }: { links: HeaderLink[] }) {
  const [open, setOpen] = React.useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger className='md:hidden' render={<Button variant='ghost' size='icon' />}>
        <Menu className='size-5' />
      </SheetTrigger>
      <SheetContent side='right' className='w-64 p-4'>
        <div className='mt-8 flex flex-col gap-6'>
          {links.map((link) => (
            <Link
              key={link.name}
              href={link.href}
              className='text-sm text-muted-foreground transition-colors hover:text-foreground'
              onClick={() => setOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <Separator />
          <div className='flex flex-col gap-3'>
            <Link href='/login' onClick={() => setOpen(false)}>
              <Button variant='ghost' size='sm' className='w-full justify-start'>
                Log in
              </Button>
            </Link>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
